<svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="m6 18 1.4 1.4 7.6-7.6V30h2V11.8l7.6 7.6L26 18 16 8 6 18ZM6 8V4h20v4h2V4c0-1.2-.8-2-2-2H6c-1.2 0-2 .8-2 2v4h2Z"
    fill="currentColor"
  />
</svg>
